type ImportObject<PropType> = {
    [key: string]: PropType;
};

const esImportToArray = <PropType>(
    importObject: ImportObject<PropType>
): PropType[] => Object.keys(importObject).map(key => importObject[key]);

export { esImportToArray };
